import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Badge } from '../ui/badge';
import { Clock, RefreshCw, Loader2 } from 'lucide-react';

const ActivityLogTab = ({ activityLog, activityFilters, setActivityFilters, loadingActivity, fetchActivityLog }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2"><Clock className="h-5 w-5 text-[#4B2D6E]" />Platform Activity Log</CardTitle>
      <CardDescription>Full audit trail of all actions taken on the platform</CardDescription>
    </CardHeader>
    <CardContent>
      <div className="flex flex-wrap gap-3 mb-4">
        <Input placeholder="Filter by name..." value={activityFilters.actor_name} onChange={(e) => setActivityFilters(prev => ({ ...prev, actor_name: e.target.value }))} className="w-48" data-testid="activity-filter-name" />
        <select value={activityFilters.category} onChange={(e) => setActivityFilters(prev => ({ ...prev, category: e.target.value }))} className="border rounded-md px-3 py-2 text-sm" data-testid="activity-filter-category">
          <option value="">All Categories</option><option value="candidate">Candidate</option><option value="job">Job</option><option value="general">General</option>
        </select>
        <Input type="date" value={activityFilters.start_date} onChange={(e) => setActivityFilters(prev => ({ ...prev, start_date: e.target.value }))} className="w-40" data-testid="activity-filter-start" />
        <Input type="date" value={activityFilters.end_date} onChange={(e) => setActivityFilters(prev => ({ ...prev, end_date: e.target.value }))} className="w-40" data-testid="activity-filter-end" />
        <Button onClick={() => fetchActivityLog()} variant="outline" data-testid="activity-search-btn"><RefreshCw className="mr-2 h-4 w-4" />Search</Button>
      </div>
      {loadingActivity ? (
        <div className="flex items-center justify-center py-12"><Loader2 className="h-8 w-8 animate-spin text-[#4B2D6E]" /></div>
      ) : activityLog.length === 0 ? (
        <div className="text-center py-12 text-[#999]"><Clock className="h-10 w-10 mx-auto mb-2 opacity-50" /><p>No activity logged yet. Click "Search" to load activity.</p></div>
      ) : (
        <div className="space-y-2 max-h-[600px] overflow-y-auto">
          {activityLog.map((entry) => (
            <div key={entry.id} className="flex items-start gap-3 p-3 bg-[#F5F5F5] rounded-lg" data-testid={`activity-entry-${entry.id}`}>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0 ${entry.actor_role === 'owner' ? 'bg-[#4B2D6E]' : entry.actor_role === 'va' ? 'bg-blue-500' : 'bg-amber-500'}`}>{entry.actor_name?.charAt(0)?.toUpperCase() || '?'}</div>
              <div className="flex-1 min-w-0">
                <p className="text-sm"><span className="font-medium text-[#333]">{entry.actor_name}</span>{' '}<span className="text-[#666]">{entry.action}</span>{entry.candidate_name && <span className="text-[#333]"> — {entry.candidate_name}</span>}</p>
                {entry.job_title && <p className="text-xs text-[#999]">{entry.job_title}</p>}
                <p className="text-xs text-[#999] mt-1">{new Date(entry.timestamp).toLocaleString()}</p>
              </div>
              <Badge className={`text-xs flex-shrink-0 ${entry.actor_role === 'owner' ? 'bg-[#4B2D6E]/10 text-[#4B2D6E]' : entry.actor_role === 'va' ? 'bg-blue-50 text-blue-700' : 'bg-amber-50 text-amber-700'}`}>
                {entry.actor_role === 'va' ? 'Team Member' : entry.actor_role === 'owner' ? 'Owner' : 'Support'}
              </Badge>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);

export { ActivityLogTab };
